import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'sonner'

import App from '@/App.tsx'
import { ConfirmProvider } from '@/components/ConfirmProvider'
import { TooltipProvider } from '@/components/ui/tooltip'
import { AdminI18nProvider } from '@/lib/i18n/AdminI18nProvider'
import { queryClient } from '@/lib/query-client'
import { initSentry } from '@/lib/sentry'

import './index.css'

initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AdminI18nProvider>
        <TooltipProvider delayDuration={200} skipDelayDuration={0}>
          <ConfirmProvider>
            <App />
          </ConfirmProvider>
        </TooltipProvider>
        <Toaster richColors position="top-right" />
      </AdminI18nProvider>
    </QueryClientProvider>
  </StrictMode>,
)
